// frontend/modules/in-app-notifications/components/NotificationBell.tsx
import React, { useState } from 'react';
import { Badge, Button, Drawer, Spin, Empty } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import { useInAppNotifications } from '../hooks/useInAppNotifications';
import { NotificationDrawer } from './NotificationDrawer';
import { useTheme } from '@/components/common/ThemeProvider';

interface NotificationBellProps {
    className?: string;
}

export const NotificationBell: React.FC<NotificationBellProps> = ({ className }) => {
    const [drawerVisible, setDrawerVisible] = useState(false);
    const { stats, isLoading } = useInAppNotifications();
    const { dark } = useTheme();

    const handleBellClick = () => {
        setDrawerVisible(true);
    };

    const handleDrawerClose = () => {
        setDrawerVisible(false);
    };

    return (
        <>
            <Badge 
                count={stats?.unreadCount || 0} 
                size="small"
                className={className}
            >
                <Button
                    type="text"
                    icon={<BellOutlined />}
                    onClick={handleBellClick}
                    className={`notification-bell ${dark ? 'text-white hover:bg-gray-700' : 'text-gray-600 hover:bg-gray-100'}`}
                    loading={isLoading}
                />
            </Badge>

            <NotificationDrawer
                visible={drawerVisible}
                onClose={handleDrawerClose}
            />
        </>
    );
};
